export default __webpack_public_path__ + "static/media/icon-sidebar-arrow.77dbd42c.svg";